import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHealthRelationSlice = createSlice({
  name: "getHealthRelation",
  initialState,
  reducers: {
    getHealthRelationStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHealthRelationSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHealthRelationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHealthRelationStart,
  getHealthRelationSuccess,
  getHealthRelationFailure,
  clearError,
  clearMessage,
} = getHealthRelationSlice.actions;

export default getHealthRelationSlice.reducer;
